import React from 'react';
import styled from 'styled-components';
import SearchBarContext from '../context';
import RecentEntry from './recent-entry';
import { saveEvent } from '../../../../../shared/search-event';

const Title = styled.h5`
  text-transform: uppercase;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 14px;
  color: ${props => props.theme.primaryColor};
  margin: 0;
`;

const Line = styled.div`
  text-transform: none;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 14px;
  margin: 0 -1em;
  padding: 0 1em;
  border-radius: 4px;
  color: ${props => props.theme.secondaryColor};
  background-color: ${props => (props.highlight ? props.theme.secondaryColorLight : 'white')};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default function RecentSearches() {
  const {
    state: {
      caret, rsearch, highlightedArea,
    },
    dispatch,
  } = React.useContext(SearchBarContext);
  const [highlight, setHighlight] = React.useState(caret);

  React.useEffect(() => setHighlight(caret), [caret]);

  React.useEffect(() => {
    if (highlight !== -1 && caret < rsearch.length) {
      dispatch({ type: 'setHighlightedArea', payload: 'recent' });
    }
  }, [highlight, caret, dispatch, rsearch.length]);

  React.useEffect(() => {
    if (highlightedArea === 'suggested') {
      setHighlight(-1);
    }
  }, [highlightedArea]);

  const performSearch = q => e => {
    e.preventDefault();
    saveEvent(q).finally(() => {
      if (q.type) {
        dispatch({ type: 'setSuggestedSearchItem', payload: q });
      }
      dispatch({ type: 'search', payload: q.query });
    });
  };

  return (
    <React.Fragment>
      <Title>recent searches</Title>
      {rsearch.map((d, i) => (
        <Line
          key={`recent-search-line-${d.id}`}
          highlight={i === highlight}
          onClick={performSearch(d)}
          onMouseEnter={() => setHighlight(i)}
        >
          <RecentEntry {...d} />
        </Line>
      ))}
    </React.Fragment>
  );
}
